import keycloak from '../keycloak';

const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8080';

// Garante que o token está válido (renova se estiver perto de expirar) e
// devolve o header Authorization pronto para usar no fetch.
async function authHeader() {
    try {
        await keycloak.updateToken(30);
    } catch (e) {
        console.error('Não foi possível renovar o token, efetuando logout.', e);
        keycloak.logout();
        return {};
    }
    return { Authorization: `Bearer ${keycloak.token}` };
}

let lastCall = "";
const Service = {
    POST: async function (url, dado) {
        const auth = await authHeader();
        return fetch(API_BASE_URL + url, {
            method: "POST",
            body: JSON.stringify(dado),
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                ...auth
            },
            credentials: 'include'
        }).then(r => {
            if (r.ok) {
                return r.json();
            } else {
                return r.json().then(erro => {
                    console.error("---->", erro);
                    if (erro.status === 500) {
                        if (erro.message.includes("signature does not match") ||
                            erro.message.includes("JWT expired")
                        ) {
                            Service.gotoLogin();
                            throw "Problema ao verificar credenciais do usuário. Efetue novo login.";
                        } else {
                            throw (erro && erro.message) ? erro.message : "";
                        }
                    } else {
                        throw erro;
                    }
                });
            }
        });
    },

    GET: async function (url, setWait) {
        // console.log("2");
        if( setWait) setWait(true);
        // if (lastCall === url) return new Promise(function (resolve, reject) {
        //     if( setWait)setWait(false);
        //     reject(Error("duplicado"));
        // })
        lastCall = url
        const auth = await authHeader();
        return fetch(API_BASE_URL + url, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                ...auth
            }
        }).then(r => {
            if (r.ok) {
                // console.log("3");
                if( setWait) setWait(false);
                return r.json();
            } else {
                // console.log("4");
                if( setWait) setWait(false);
                if (typeof r === "object") {
                    throw r;
                }
                return r.json().then(erro => {

                    console.error("Erro da requisicao: ", erro);
                    if (erro.status === 500) {
                        if (erro.message.includes("signature does not match") ||
                            erro.message.includes("JWT expired")
                        ) {
                            Service.gotoLogin();
                            throw "Problema ao verificar credenciais do usuário. Efetue novo login.";
                        } else {
                            throw (erro && erro.message) ? erro.message : "";
                        }
                    } else {
                        throw erro;
                    }
                });
            }
        });
    },

    DELETE: async function (url, dado) {
        const auth = await authHeader();
        return fetch(API_BASE_URL + url, {
            method: "DELETE",
            body: JSON.stringify(dado),
            headers: {
                'Content-Type': 'application/json',
                // Accept: 'application/json',
                ...auth
            },
            credentials: 'include'
        }).then(r => {
            if (r.ok) {
                return r;
            } else {
                return r.then(erro => {
                    console.error("---->", erro);
                    if (erro.status === 500) {
                        if (erro.message.includes("signature does not match") ||
                            erro.message.includes("JWT expired")
                        ) {
                            Service.gotoLogin();
                            throw "Problema ao verificar credenciais do usuário. Efetue novo login.";
                        } else {
                            throw (erro && erro.message) ? erro.message : "";
                        }
                    } else {
                        throw erro;
                    }
                });
            }
        });
    },

    gotoLogin: function () {
        keycloak.logout({ redirectUri: window.location.origin });
    },

};


export default Service;
